module.exports = __webpack_public_path__ + "img/process-3.614d61ee.png";